module.exports = __webpack_public_path__ + "static/media/Ladder.e02b02a5.JPG";